import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Planning for the Future: Transforming iPhone App Development in
              the Heart of London
            </h2>
            <p>
              As one of the premium iPhone app development companies in London,
              TekRevol's iOS app development services aim to facilitate your
              growth and adaptation in a fast-paced environment. Using
              state-of-the-art technology, we craft iPhone apps that confer a
              competitive advantage and elevate customer engagement.
            </p>
            <p>
              Our skilled team collaborates closely with you to comprehend your
              distinctive business requirements and objectives.
            </p>
            <p>
              We then customize our iPhone app development process to provide
              scalable solutions that evolve with your business expansion. Count
              on TekRevol as a leading iPhone app development company that
              creates the digital tools essential for staying ahead in the UK
              market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../../images/location_new/fold11/Uk.webp"
                alt="iphone-ios-app-development-companies-london"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
